import { defineFcm } from '../shared/factory';

export const FCM_DOUBLE_OPT_IN_PETITION_LIST = defineFcm('double_opt_in_petition_list')
	.asString()
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'monorail',
		context: 'monorail',
		description: 'Allows individual petitions to require double opt-in. Comma-separated list of petition IDs.',
		import: false,
	});
